import styled from 'styled-components'
import { theme } from '@fe-toolkit/web-components/ssr'

// Styled component for the submenu list
// Warning: there is a lot of hardcoded styling here
// as it needed to explicitly match the existing portal menu
// TODO: confirm if this is still needed with the new design system
export const SubMenuNav = styled.nav`
  font-size: 15px;
  max-width: 933px;
  margin-left: auto;
  margin-right: auto;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    ${theme.breakpoints.up('medium')} {
      display: flex;
      flex-direction: row;
    }

    > li {
      border-top: 1px solid ${theme.colors.white};
      display: flex;

      &.toggleable {
        display: none;

        ${theme.breakpoints.up('medium')} {
          display: block;
        }
      }

      > a {
        display: block;
        padding: 14px 18px 12px;

        ${theme.breakpoints.up('medium')} {
          align-items: center;
          border-bottom: 4px solid transparent;
          display: flex;
          height: 41px;
          padding: 5px 16px 7px;
        }
      }

      > button {
        font-size: ${theme.fontSizes.speak};
        font-weight: bold;
        padding: 17px 18px 14px 34px;
        position: relative;
        text-align: left;
        width: 100%;

        > span {
          font-size: 25px;
          font-weight: normal;
          left: 5px;
          margin-top: -1px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }

        ${theme.breakpoints.up('medium')} {
          display: none;
        }
      }

      &.active > a {
        display: none;
        font-size: ${theme.fontSizes.speak};
        font-weight: bold;
        
        ${theme.breakpoints.up('medium')} {
          border-bottom: 4px solid ${theme.colors.white};
          font-size: 15px;
          display: block;
        }
      }

      ${theme.breakpoints.up('medium')} {
        border-top: none;
      }

      &:hover:not(.active) > a {
        background-color: #2f2e31;
        text-decoration: none;
      }
    }
  }
}
`
